import { z } from 'zod';
import { PasswordSchema } from './auth.schema.js';

export const VerifyTokenRequestSchema = z.object({
  token: z.string().min(1),
});
export type VerifyTokenRequest = z.infer<typeof VerifyTokenRequestSchema>;

export const TestDbRequestSchema = z.object({
  host: z.string().min(1).default('localhost'),
  port: z.coerce.number().int().positive().default(3306),
  database: z.string().min(1),
  user: z.string().min(1),
  password: z.string(),
});
export type TestDbRequest = z.infer<typeof TestDbRequestSchema>;

export const CreateAdminRequestSchema = z.object({
  fullName: z.string().min(2),
  email: z.string().email().toLowerCase(),
  phone: z.string().optional(),
  password: PasswordSchema,
});
export type CreateAdminRequest = z.infer<typeof CreateAdminRequestSchema>;

export const InstallStatusSchema = z.object({
  data: z.object({
    isInstalled: z.boolean(),
    completedSteps: z.array(z.string()),
  }),
});
export type InstallStatus = z.infer<typeof InstallStatusSchema>;
